import axios from "../../../api/axios";

const BASE = "/v2/hot-water-tank-flushes";

const handleApiError = (error, defaultMessage) => {
  const message =
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error?.message ||
    defaultMessage;
  throw new Error(message);
};

export const getTownhouseOptions = async () => {
  try {
    const { data } = await axios.get(`${BASE}/options`);
    return data.data || [];
  } catch (error) {
    handleApiError(error, "Failed to load townhouse properties");
  }
};

export const getTownhouseUnits = async (propertyId, buildingName) => {
  try {
    const { data } = await axios.get(`${BASE}/units`, { params: { propertyId, buildingName } });
    return data.data || [];
  } catch (error) {
    handleApiError(error, "Failed to load units");
  }
};

export const getFlushRecords = async (params = {}) => {
  try {
    const { data } = await axios.get(BASE, { params });
    return data.data || [];
  } catch (error) {
    handleApiError(error, "Failed to load hot water tank records");
  }
};

export const createFlushRecord = async (payload) => {
  try {
    const { data } = await axios.post(BASE, payload);
    return data.data;
  } catch (error) {
    handleApiError(error, "Failed to record hot water tank flush");
  }
};

export const updateFlushRecord = async (id, payload) => {
  try {
    const { data } = await axios.patch(`${BASE}/${id}`, payload);
    return data.data;
  } catch (error) {
    handleApiError(error, "Failed to update record");
  }
};

export const deleteFlushRecord = async (id) => {
  try {
    await axios.delete(`${BASE}/${id}`);
  } catch (error) {
    handleApiError(error, "Failed to delete record");
  }
};

export const removeFlushAttachment = async (id, key) => {
  try {
    const { data } = await axios.delete(`${BASE}/${id}/attachments`, { data: { key } });
    return data.data;
  } catch (error) {
    handleApiError(error, "Failed to remove attachment");
  }
};

// Presigned PUT straight to storage, then record the key on the flush.
export const uploadFlushAttachment = async (id, file) => {
  try {
    const { data } = await axios.post(`${BASE}/${id}/upload-request`, {
      fileName: file.name,
      contentType: file.type,
    });
    const { presignedUrl, key } = data.data;
    const put = await fetch(presignedUrl, {
      method: "PUT",
      body: file,
      headers: { "Content-Type": file.type },
    });
    if (!put.ok) throw new Error(`Upload failed for ${file.name}`);
    await axios.post(`${BASE}/${id}/confirm-upload`, { key });
    return key;
  } catch (error) {
    handleApiError(error, `Upload failed for ${file.name}`);
  }
};

export const getFlushSignedUrls = async (keys) => {
  if (!keys?.length) return {};
  try {
    const { data } = await axios.post(`${BASE}/signed-urls`, { keys });
    return data.data || {};
  } catch (error) {
    handleApiError(error, "Failed to load attachments");
  }
};
